export const en = {
  documents: {
    startDialog: {
      start: 'Start now',
      resume: 'Resume reading',
      restart: 'Read again',
      duration: 'Reading time: {{time}} minutes',
      credits: '{{credits}} Credits',
      colleaguesHint: {
        singular:
          "Another one of your colleagues has already read the document, don't fall behind!",
        plural: "Over {{colleagues}} colleagues have already read the document, don't fall behind!",
      },
      errors: {
        noCredits: 'You do not have enough credits to start the document.',
      },
    },
    player: {
      genericDocumentError: 'There was a problem loading the document. Please try again.',
      finishReading: 'I have finished reading',
    },
    confirmExitFromDocumentDialog: {
      title: 'Exit content',
      description:
        'By leaving the document, you will be able to complete it at a later time without losing your progress.',
      adminDescription:
        'If you close the document now, you won’t be able to resume from where you left off, but you can read it again from the beginning as many times as you want.',
      confirm: 'Exit',
      cancel: 'Cancel',
    },
    feedbackDocumentDialog: {
      title: 'How do you rate this document?',
      submittedTitle: 'Thanks for your feedback!',
      description: 'Rating is optional.',
      commentPlaceholder: 'Leave a comment to let us know your experience',
      submittedDescription: 'Continue with the training to not miss the next available content!',
      confirm: 'Submit',
      backToTraining: 'Back to training',
    },
  },
};
